<template>
  <div class="import-panel-box">
    <!-- 导入与下载区域 -->
    <div class="top-box">
      <el-upload
        class="avatar-uploader"
        action
        :file-list="fileList"
        :show-file-list="true"
        accept=".xlsx,"
        :auto-upload="false"
        :multiple="false"
        :limit="1"
        :on-change="handleBatchImport"
        :on-exceed="handleExceed"
        :on-remove="handleRemove"
        :before-remove="beforeRemove"
      >
        <i class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <div class="top-right-box" @click="handleDownLoadTemplate">
        没有模板? 请先
        <span style="text-decoration: underline; font-size: 16px; color: blue"
          >下载模板</span
        >
      </div>
    </div>
    <!-- <div class="format-box">
      支持格式: .xls、.xlsx、.csv, 单个文件不超过10MB
    </div> -->
    <div class="import-progress-box">
      <div style="margin-right: 10px">实时导入进度</div>
      <subProgress
        :addGray="true"
        :progressWidth="progressWidth"
        ref="subProgress"
      ></subProgress>
      <div style="margin-left: 15px">{{ progressWidth }} %</div>
    </div>
    <div class="import-record-title-box">导入记录：</div>
    <div class="import-record-content-box">
      {{ importRecordObj.date ? importRecordObj.date : "暂无导入日期" }}
      导入 {{ importRecordObj.total }} 条数据 成功
      {{ importRecordObj.success }} 条
      <span
        style="
          text-decoration: underline;
          font-size: 16px;
          color: blue;
          cursor: pointer;
        "
        @click="handleCheckOpt"
        >请核对</span
      >, 失败 {{ importRecordObj.fail }} 条
      <span
        style="
          text-decoration: underline;
          font-size: 16px;
          color: blue;
          cursor: pointer;
        "
        @click="handleViewOpt"
        >请查看原因。</span
      >
    </div>
    <!-- 录入成功-核对表格 -->
    <el-dialog
      title="成功列表"
      :append-to-body="true"
      :visible.sync="dialogCheck"
      width="60vw"
      class="choose-container"
      @close="handleCloseCheckSave"
    >
      <div style="height: 66vh">
        <ioc-table
          ref="entrySuccessTable"
          :data="checkData"
          :option="checkOption"
          :page="checkPage"
          @size-change="handleCheckSizeChange"
          @current-change="handleCheckCurrentChange"
        >
          <template slot="custom" slot-scope="scope">
            <el-input v-model="scope.row.custom" clearable></el-input>
          </template>
          <template slot="driverName" slot-scope="scope">
            <el-input v-model="scope.row.driverName" clearable></el-input>
          </template>
          <template slot="phone" slot-scope="scope">
            <el-input v-model="scope.row.phone" clearable></el-input>
          </template>
          <template slot="frontPlate" slot-scope="scope">
            <el-input v-model="scope.row.frontPlate" clearable></el-input>
          </template>
          <template slot="cabinetNumber" slot-scope="scope">
            <el-input v-model="scope.row.cabinetNumber" clearable></el-input>
          </template>
          <template slot="operateType" slot-scope="scope">
            <el-radio-group v-model="scope.row.operateType">
              <el-radio :label="'1'">装货</el-radio>
              <el-radio :label="'2'">卸货</el-radio>
              <el-radio :label="'3'">过车</el-radio>
            </el-radio-group>
          </template>
          <template slot="passType" slot-scope="scope">
            <el-radio-group
              v-model="scope.row.passType"
              :disabled="scope.row.operateType == '3' ? false : true"
            >
              <el-radio :label="'1'">倒入</el-radio>
              <el-radio :label="'2'">倒出</el-radio>
            </el-radio-group>
          </template>
          <template slot="waresName" slot-scope="scope">
            <el-input v-model="scope.row.waresName" clearable></el-input>
          </template>
          <template slot="waresCount" slot-scope="scope">
            <el-input
              v-model.number="scope.row.waresCount"
              clearable
            ></el-input>
          </template>
          <template slot="waresWeight" slot-scope="scope">
            <el-input v-model="scope.row.waresWeight" clearable></el-input>
          </template>
          <template slot="warehouseNumber" slot-scope="scope">
            <el-input v-model="scope.row.warehouseNumber" clearable></el-input>
          </template>
          <template slot="estimatedArrivalTime" slot-scope="scope">
            <el-date-picker
              clearable
              v-model="scope.row.estimatedArrivalTime"
              type="date"
              placeholder="请选择日期"
              style="width: 100%"
              format="yyyy/MM/dd"
              value-format="yyyy/MM/dd"
            >
            </el-date-picker>
          </template>
          <template slot="warehousingDate" slot-scope="scope">
            <el-date-picker
              clearable
              v-model="scope.row.warehousingDate"
              type="date"
              placeholder="请选择日期"
              style="width: 100%"
              format="yyyy/MM/dd"
              value-format="yyyy/MM/dd"
            >
            </el-date-picker>
          </template>
        </ioc-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <!-- <el-button type="info" @click="cancelChoose">取消</el-button> -->
        <el-button type="primary" @click="handleCheckSave">核对保存</el-button>
      </div>
    </el-dialog>

    <!-- 录入失败-查看表格 -->
    <el-dialog
      title="失败列表"
      :append-to-body="true"
      :visible.sync="dialogView"
      width="40vw"
      class="choose-container"
      @close="handleViewClose"
    >
      <div style="height: 66vh">
        <ioc-table
          ref="entrySuccessTable"
          :data="viewData"
          :option="viewOption"
          :page="viewPage"
          @size-change="handleViewSizeChange"
          @current-change="handleViewCurrentChange"
        >
        </ioc-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="handleViewClose">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { api } from "../api";
import utils from "@src/common/utils";
import checkTableOption from "../const/crud/entrySuccess.js";
import viewTableOption from "../const/crud/entryFail.js";
import subProgress from "./progress.vue";

export default {
  components: { subProgress },
  props: {},
  data() {
    return {
      downFileName: "batchImportTemplate",
      progressWidth: 0,
      myInterval: null,
      fileList: [],
      // 导入记录对象
      importRecordObj: {
        date: "",
        total: 0,
        fail: 0,
        success: 0,
      },
      checkOption: checkTableOption(this),
      checkData: [],
      dialogCheck: false,
      isChecked: false,
      checkPage: {
        pageNum: 1,
        total: 1,
        pageSize: utils.Cache.get("CURRENT_pageSize") || 10,
      },

      viewOption: viewTableOption(this),
      viewData: [],
      dialogView: false,
      viewPage: {
        pageNum: 1,
        // total: 0,
        total: 0,
        pageSize: utils.Cache.get("CURRENT_pageSize") || 10,
      },
    };
  },
  mounted() {
    this.parkType = [utils.Cache.get("CACHE_USER_INFO").parkInfoTree];
  },
  methods: {
    handleExceed(files, fileList) {
      this.$message.warning(`最多只能上传 1 个文件！`);
    },
    handleRemove(file, fileList) {
      console.log("Remove:", file, fileList);
    },
    beforeRemove(file, fileList) {
      return this.$confirm(`确定移除 ${file.name}?`);
    },
    // 校验文件格式
    validFileFormat(file) {
      const isLt10M = file.size / 1024 / 1024 <= 10;
      const fileName = file.name;
      const type = fileName.slice(
        fileName.lastIndexOf(".") + 1,
        fileName.length
      );
      const fileArr = ["xlsx"];
      let isFile = null;
      fileArr.indexOf(type) === -1 ? (isFile = false) : (isFile = true);
      if (!isFile) {
        this.$message.error("文件格式不正确! ");
        return false;
      }
      if (!isLt10M) {
        this.$message.error("文件大小不正确! ");
        return false;
      }
      return true;
    },
    // 清除进度条更新定时器
    clearProgressInterval() {
      if (this.myInterval) {
        clearInterval(this.myInterval);
      }
    },
    // 批量导入操作
    handleBatchImport(file) {
      if (!this.validFileFormat(file)) {
        this.fileList = [];
        return false;
      } else {
        // 更新进度条
        this.clearProgressInterval();
        this.myInterval = setInterval(() => {
          if (this.progressWidth < 100) {
            this.progressWidth = this.progressWidth + 10;
          }
        }, 1000);
        let formData = new FormData();
        formData.append("file", file.raw);
        // 调用导入接口
        this.$fetch(api.import.uploadTemplateFile, formData).then(
          (response) => {
            if (response.success) {
              this.$message({
                message: "导入文件成功",
                type: "success",
              });
              this.progressWidth = 100;
              console.log("-obj:-", Object.keys(response.returnObj).length);
              if (Object.keys(response.returnObj).length != 0) {
                this.importRecordObj.date = response.returnObj.date;
                this.importRecordObj.fail = response.returnObj.fail;
                this.importRecordObj.success = response.returnObj.success;
                this.importRecordObj.total =
                  Number(response.returnObj.fail) +
                  Number(response.returnObj.success);
              } else {
                this.importRecordObj.date = "";
                this.importRecordObj.total = 0;
                this.importRecordObj.fail = 0;
                this.importRecordObj.success = 0;
              }
            } else {
              this.$message({
                message: response.prompt,
                type: "error",
              });
              setTimeout(() => {
                clearInterval(this.myInterval);
                this.progressWidth = 0;
              }, 2000);
            }
            // this.$refs.upload.clearFiles();
          }
        );
      }
    },
    //模板下载
    handleDownLoadTemplate() {
      this.$fetchGet(api.import.getTemplateFile, {
        responseType: "blob", //设置返回类型
      }).then((res) => {
        if (typeof window.chrome !== "undefined") {
          // Chrome version
          const blob = new Blob([res], { type: "application/vnd.ms-excel" });
          const url = window.URL || window.webkitURL || window.moxURL;
          const urls = url.createObjectURL(blob);
          const a = document.createElement("a"); // 生成虚拟a标签
          a.href = urls;
          a.download = this.downFileName + ".xlsx";
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          url.revokeObjectURL(urls); // 释放掉blob对象
        } else if (typeof window.navigator.msSaveBlob !== "undefined") {
          // IE version
          const blob = new Blob([res], { type: "application/force-download" });
          window.navigator.msSaveBlob(blob, this.downFileName + ".xlsx");
        } else {
          // Firefox version
          const file = new File([res], this.downFileName + ".xlsx", {
            type: "application/force-download",
          });
          window.open(URL.createObjectURL(file));
        }
      });
    },
    // 导入成功--表格核对
    handleCheckOpt() {
      console.log("-核对操作-");
      if (this.importRecordObj.total === 0) {
        this.$message({
          message: "请先导入数据",
          type: "warning",
          duration: 2000,
        });
      } else {
        this.getImportSuccessData();
        // console.log("-success:-", this.importRecordObj.success);
        // console.log("-checkPageTotal:-", this.checkPage.total);
        // if (this.importRecordObj.success === 0) {
        //   console.log("-success-0-");
        //   this.$message({
        //     message: "暂无要核对的数据",
        //     type: "warning",
        //     duration: 2000,
        //   });
        // } else {
        //   if (this.checkPage.total == 0) {
        //     this.$message({
        //       message: "暂无要核对的数据",
        //       type: "warning",
        //       duration: 2000,
        //     });
        //   } else {
        //     this.getImportSuccessData();
        //   }
        // }
      }
    },
    // 导入失败--表格查看
    handleViewOpt() {
      console.log("-查看操作-");
      if (this.importRecordObj.total === 0) {
        this.$message({
          message: "请先导入数据",
          type: "warning",
          duration: 2000,
        });
      } else {
        if (this.importRecordObj.fail === 0) {
          this.$message({
            message: "暂无要查看的数据",
            type: "warning",
            duration: 2000,
          });
        } else {
          this.getImportFailData();
        }
      }
    },
    // 获取核对--成功表格数据
    getImportSuccessData() {
      this.isChecked = true;
      this.$fetch(api.import.queryAnalyzeData, {
        ifSuccess: "success",
        pageNum: this.checkPage.pageNum,
        pageSize: this.checkPage.pageSize,
      }).then((res) => {
        // 有需要核对的数据, 不关闭当前弹窗
        if (res.success && res.returnObj.total > 0) {
          this.$message({
            message: "数据查询成功",
            type: "success",
            duration: 2000,
          });
          this.dialogCheck = true;
          this.checkPage.total = res.returnObj.total;
          // 数据需要做处理
          this.checkData = res.returnObj.list;
          this.checkData.forEach((item) => {
            if (item.estimatedArrivalTime) {
              item.estimatedArrivalTime = item.estimatedArrivalTime.replaceAll(
                "-",
                "/"
              );
            }
            if (item.warehousingDate) {
              item.warehousingDate = item.warehousingDate.replaceAll("-", "/");
            }
          });
          console.log("-11-checkData:-", this.checkData);
          // 无需要核对的数据，关闭当前弹窗
        } else if (res.success && res.returnObj.total == 0) {
          this.$message({
            message: "暂无要核对的数据",
            type: "success",
            duration: 2000,
          });
          this.dialogCheck = false;
          this.checkPage.total = 0;
          this.checkData = [];
          console.log("-00-checkData:-", this.checkData);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
            duration: 2000,
          });
          this.dialogCheck = false;
          this.checkPage.total = 0;
          this.checkData = [];
        }
      });
    },
    handleCheckCurrentChange(val) {
      this.checkPage.pageNum = val;
      // 获取核对表格数据
      this.getImportSuccessData();
    },
    handleCheckSizeChange(val) {
      this.checkPage.pageNum = 1;
      this.checkPage.pageSize = val;
      // 获取核对表格数据
      this.getImportSuccessData();
    },
    // 处理--关闭核对保存操作
    handleCloseCheckSave() {
      this.dialogCheck = false;
    },
    // 处理核对保存操作
    handleCheckSave() {
      console.log("-核对保存-");
      this.$fetch(api.import.customerImportData, { list: this.checkData }).then(
        (res) => {
          if (res.success) {
            this.$message({
              message: "数据核对成功",
              type: "success",
              duration: 2000,
            });
            // this.dialogCheck = false;
            // this.$emit("save-import-info");
            // 不关闭当前弹窗, 再次调用列表接口
            this.getImportSuccessData();
          } else {
            this.$message({
              message: res.msgContent,
              type: "error",
              duration: 2000,
            });
            // this.dialogCheck = false;
          }
        }
      );
    },
    // 获取查看原因--失败表格数据
    getImportFailData() {
      this.$fetch(api.import.queryAnalyzeData, {
        ifSuccess: "fail",
        pageNum: this.viewPage.pageNum,
        pageSize: this.viewPage.pageSize,
      }).then((res) => {
        if (res.success) {
          this.$message({
            message: "数据查询成功",
            type: "success",
            duration: 2000,
          });
          this.dialogView = true;
          this.viewPage.total = res.returnObj.total;
          this.viewData = res.returnObj.list;
          console.log("-viewData:-", this.viewData);
        } else {
          this.$message({
            message: res.msgContent,
            type: "error",
            duration: 2000,
          });
          this.dialogView = false;
        }
      });
    },
    handleViewCurrentChange(val) {
      this.viewPage.pageNum = val;
      // 获取查看表格数据
      this.getImportFailData();
    },
    handleViewSizeChange(val) {
      this.viewPage.pageNum = 1;
      this.viewPage.pageSize = val;
      // 获取查看表格数据
      this.getImportFailData();
    },
    // 处理查看关闭操作
    handleViewClose() {
      console.log("-查看关闭-");
      this.dialogView = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.import-panel-box {
  width: 100%;
  height: 99%;

  .top-box {
    width: 100%;
    height: 45%;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    .avatar-uploader {
      /deep/.el-upload {
        border: 2px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
      }
      .el-upload:hover {
        border-color: #409eff;
      }
      .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 180px;
        height: 180px;
        line-height: 180px;
        text-align: center;
      }
      .avatar {
        width: 180px;
        height: 180px;
        display: block;
      }
    }
    .top-right-box {
      width: 180px;
      height: 180px;
      margin-left: 5%;
      display: flex;
      flex-direction: row;
      align-items: flex-end;
      justify-content: center;
      padding-bottom: 10px;
      cursor: pointer;
    }
  }
  .format-box {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24%;
  }
  .import-progress-box {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24%;
  }
  .import-record-title-box {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24%;
  }
  .import-record-content-box {
    width: 100%;
    height: 50px;
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-left: 24%;
  }
}
</style>
